/**
 * Handle Euneos register click
 * @param {string} uid
 * @return {void}
 */
function handleEuneosRegisterClick(uid) {
	window.dataLayer.push({
		event: 'link_click',
		event_category: 'register',
		event_label: uid,
	});
}

export { handleEuneosRegisterClick };
